<template>
	<div id="app">		
		<component :is="layout" >
			<transition name="fade">
				<router-view />
			</transition>
		</component>		
	</div>
</template>

<script>

// Главный компонент приложения

export default {
	computed: {		
		layout() {
			// Вернем имя шаблона из роута или дефолтное значение 
			// (шаблон для страниц, для которых мы не указали шаблон)
			return this.$route.meta.layout || "inside-layout"
		}
	}	
}
</script>

<style>
@import '@/assets/fonts/opensans.css';
@import '@/assets/css/style.css';

#app {
	padding: 0;
	margin: 0;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>